import { useEffect, useState } from 'react';

/**
 * CPAYMENT-1718: экран шире мобильного брейкпоинта проекта.
 * Порог держим в одной точке с `@mixin mobile` (src/styles/mixins.scss = max-width 540px),
 * поэтому desktop — это `min-width: 541px`.
 *
 * Слушаем `change` у MediaQueryList, а не разовый замер на маунте: при ресайзе окна
 * (или повороте планшета) видимость зависимых блоков должна пересчитываться, а не
 * «залипать» в режиме первого рендера.
 */
const DESKTOP_QUERY = '(min-width: 541px)';

const matches = (): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(DESKTOP_QUERY).matches;

const useIsDesktop = (): boolean => {
  const [isDesktop, setIsDesktop] = useState<boolean>(matches);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;

    const mql = window.matchMedia(DESKTOP_QUERY);
    const onChange = (e: MediaQueryListEvent | MediaQueryList) => setIsDesktop(e.matches);

    // Между первым рендером и эффектом ширина могла измениться — пересчитываем.
    setIsDesktop(mql.matches);

    // Safari < 14 не умеет addEventListener на MediaQueryList.
    if (typeof mql.addEventListener === 'function') {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }

    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return isDesktop;
};

export default useIsDesktop;
